// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2530": "e96a97f91d26","3087": "0b23ffe7053a","4774": "e53406801cd7","5336": "5083bc5218c4","7098": "fbf1fdab182a","7913": "73792077d354","8236": "2875b2efe26c","9897": "ecea66ad12b5",}[chunkId] + ".css"
}